module.exports = __webpack_public_path__ + "img/anthem-bc-logo.392b6d6d.png";